module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": _vm.attachmentsImport_ImportFile,
      "returnPreviousPage": _vm.isSmartphone
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 offset-md-1"
  }, [_c('div', {
    staticClass: "panel21 panel-default"
  }, [_c('h4', {
    staticClass: "content-block labelAccordionForm"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "list_bullet"
    }
  }), _vm._v(" "), (this.service === 'Direct Payments') ? _c('span', [_vm._v("\n                " + _vm._s(_vm.$t('attachments.import_refund')) + "\n              ")]) : _c('span', [_vm._v("\n                " + _vm._s(_vm.$t('attachments.import_invoice')) + "\n              ")])], 1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-2 col-form-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rfrnc')))]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reference),
      expression: "reference"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reference",
      "placeholder": _vm.attachmentsImport_Reference,
      "type": "text"
    },
    domProps: {
      "value": (_vm.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reference = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-2",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "button-inner-color fileContainer"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('common.chse_file')) + "\n                "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "name": "file2",
      "id": "file2"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attachmentName),
      expression: "attachmentName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "filename",
      "placeholder": _vm.attachmentsImport_chseFile,
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.attachmentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.attachmentName = $event.target.value
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2 offset-md-9",
    class: _vm.colorBottomButton
  }, [_c('button', {
    staticClass: "importAttachmentButton button-action firstButtonMarginTop",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.importAttachment
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "list_bullet"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('attachments.imprt')))])], 1)])])]), _vm._v(" "), _c('canvas', {
    staticClass: "hiddenElement",
    attrs: {
      "id": "pdf-canvas",
      "width": "1000"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21ee7809", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ee7809","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/attachments/CMAttachmentsImport.vue
// module id = 1639
// module chunks = 2